export default __webpack_public_path__ + "static/media/mixpanel.66f2c370.svg";